/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var SortArrowsIcon = createIcon("SortArrowsIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 12 12",
    height: "12",
    width: "12"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M3.24 2.562a.75.75 0 00-.75.75v5.055a.124.124 0 01-.125.124H1.74a.5.5 0 00-.428.759l1.5 2.5a.5.5 0 00.858 0l1.5-2.5a.5.5 0 00-.43-.757h-.625a.125.125 0 01-.125-.125V3.312a.75.75 0 00-.75-.75ZM8.76 9.42a.75.75 0 00.75-.75V3.617a.124.124 0 01.124-.125h.625a.5.5 0 00.429-.758l-1.5-2.5a.52.52 0 00-.858 0l-1.5 2.5a.5.5 0 00.43.758h.624a.125.125 0 01.125.125V8.67a.75.75 0 00.75.75Z"
  }));
}, {});